/* eslint-disable import/no-cycle */
import React, { useState, useEffect } from "react";
import { Loading } from "Components";
import NavBar from "ProfileComponents/Navigation/NavBar";
import { TranslucentNavbar, ReferralWidget, ReferralTable, GainfulCarousel, ReferralStat } from "ProfileComponents";
import { useDispatch, useSelector } from "react-redux";
import { useScreenWidth } from "../SubscriptionPageV2/hooks";
import styles from "./styles.module.scss";

function ReferralPage() {
  const reduxStoreIsEmpty = useSelector((state) => state.checkStore.referal);
  const isMobile = useScreenWidth() < 768;
  const { nav_visibility } = useSelector((state) => state.components);
  const referralData = useSelector((state) => state.referalInfo.referalInfo);
  const user = useSelector((state) => state.user);
  const [items, setItems] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (referralData.unconverted_friends.length > 0) {
      setItems([
        { content: <ReferralStat header="Total Saved" statistic={referralData.referral_credits_earned} /> },
        { content: <ReferralStat header="Friends Referred" statistic={referralData.purchase_people.length} /> },
        { content: <ReferralStat header="Pending Savings" statistic={referralData.possible_credits} /> },
      ]);
    }
  }, []);

  return (
    <>
      {nav_visibility && <NavBar userName={user.full_name} showTop userLoggedIn />}
      <div className={`${styles["profile-container"]} ${styles["referral-page"]}`} style={{ marginTop: "20px" }}>
        {Object.keys(referralData).length === 0 ? (
          <div style={{ marginTop: "60px" }}>
            <Loading />
          </div>
        ) : (
          <div className={styles["referral-container"]}>
            <div className="col l7 m7 s12">
              <div style={{ margin: "auto", marginRight: "0px" }} className={styles.blockwrapper}>
                {referralData.purchase_people.length === 0 ? (
                  <img
                    src="/reactjs/static/images/profile/referralHeader.svg"
                    alt=""
                    className={styles["referral-header"]}
                  />
                ) : (
                  <div>
                    <img
                      src="/reactjs/static/images/profile/referralHeader.svg"
                      alt=""
                      className={`hide-on-small-only ${styles["referral-header"]}`}
                    />
                    <div className="hide-on-med-and-up">
                      <GainfulCarousel items={items} title="Your Referrals" />
                    </div>
                  </div>
                )}
                <ReferralWidget referralData={referralData} />
              </div>
            </div>

            <div className="col l5 m6 s12">
              {referralData.unconverted_friends.length === 0 && referralData.purchase_people.length === 0 ? (
                <div>
                  <img
                    src="/reactjs/static/images/profile/referralBottom.png"
                    alt=""
                    className="hide-on-med-and-up"
                    style={{
                      margin: "20px 0 15% 50%",
                      width: "100%",
                      transform: "translateX(-50%)",
                      maxWidth: "600px",
                    }}
                  />
                </div>
              ) : (
                <div>
                  <div className="hide-on-small-only" style={{ marginBottom: "70px" }}>
                    <GainfulCarousel items={items} title="Your Referrals" />
                  </div>
                  <ReferralTable
                    unconvertedData={referralData.unconverted_friends}
                    purchaseData={referralData.purchase_people}
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      {isMobile && (
        <TranslucentNavbar animated>
          <h4>Refer A Friend</h4>
        </TranslucentNavbar>
      )}
    </>
  );
}

export default ReferralPage;
